import router from '@/shared/router'
import { formataRotasGlobais } from '@/shared/common/functions/roteamento'
import lojas from '@/domains/configuracoes/lojas/router/routes'
import usuarios from '@/domains/configuracoes/usuarios/router/routes'
import gruposUsuarios from '@/domains/configuracoes/grupos_usuarios/router/routes'
import permissoes from '@/domains/configuracoes/permissoes/router/routes'
import planos from '@/domains/configuracoes/planos/router/routes'
import dominios from '@/domains/configuracoes/dominios/router/routes'
import ajuda from '@/domains/auxiliares/ajuda/router/routes'
import backupDados from '@/domains/configuracoes/backup_dados/router/routes'
import chamados from '@/modules/atendimentos/domains/chamados/router/routes'
import assuntos from '@/modules/atendimentos/domains/assuntos/router/routes'
import formas from '@/modules/atendimentos/domains/formas/router/routes'
import situacoes from '@/modules/atendimentos/domains/situacoes/router/routes'
import camposExtras from '@/modules/atendimentos/domains/campos_extras/router/routes'
import relatorios from '@/modules/atendimentos/domains/relatorios/atendimentos/router/routes'
import api from '@/shared/services/api'

let childrenRoutes = []
const paths = require.context('../', true, /routes.js$/i)
const context = paths.keys().map(paths).map(m => m.default)

context.map((arr) => {
    if (arr) {
        arr.map((val) => { childrenRoutes.push(val) })
    }
})


const routes = [
    {
        path: '/area_cliente_adm',
        component: () => import('@/shared/components/layout/Interno'),
        children: [
            ...childrenRoutes,
            ...chamados,
            ...assuntos,
            ...formas,
            ...situacoes,
            ...camposExtras,
            ...relatorios,
            {
                name: 'ajustesAtendimentoAreaClienteAdm',
                path: 'ajustes_atendimento',
                component: () => import('@/modules/atendimentos/domains/configuracoes/gerais/views/ConfigGeraisView')
            }
        ],
    },
    {
        path: '/area_cliente_adm/sistema/acessar_erp',
        redirect: '/inicio'
    },
    {
        path: '/area_cliente_adm/notificacoes',
        redirect: '/notificacoes'
    },
    {
        name: 'impressaoChamadoAreaClienteAdm',
        path: '/area_cliente_adm/chamados/imprimir_pdf/:id',
        component: () => import('@/shared/components/ui/Impressao'),
        meta: {
            fullScreen: true,
            public: true
        }
    },

    ...formataRotasGlobais('area_cliente_adm', dominios),
    ...formataRotasGlobais('area_cliente_adm', lojas),
    ...formataRotasGlobais('area_cliente_adm', usuarios),
    ...formataRotasGlobais('area_cliente_adm', gruposUsuarios),
    ...formataRotasGlobais('area_cliente_adm', permissoes),
    ...formataRotasGlobais('area_cliente_adm', planos),
    ...formataRotasGlobais('area_cliente_adm', ajuda),
    ...formataRotasGlobais('area_cliente_adm', backupDados),
]


router.addRoutes(routes)

// Valida integração loja
router.beforeEach(async (to, from, next) => {
    const plugin = 'area_cliente_adm'

    const rotasPublicas = [
        `/${plugin}/login`,
        `/${plugin}/cadastro`,
        `/${plugin}/cadastrar_senha`,
        `/${plugin}/dois_fatores`,
        `/${plugin}/integracoes`,
        `/${plugin}/integracoes/index`,
        `/${plugin}/integracoes/adicionar`,
        `/${plugin}/planos/`
    ]

    const rotaLiberada =
        rotasPublicas.includes(to.path) ||
        to.path.startsWith(`/${plugin}/usuarios`) ||
        to.path.startsWith(`/${plugin}/grupos_usuarios`) ||
        to.path.startsWith(`/${plugin}/planos/`)

    const precisaIntegracao = !rotaLiberada

    if(precisaIntegracao){
        try{
            const retorno = await api.get(`${plugin}/integracoes/index`)
            if (!retorno.data || retorno.status == 'error') {
                router.push(`/${plugin}/integracoes/index`)
                return
            }
        }catch(error){
            router.push(`/${plugin}/integracoes/index`)
            return
        }
    }

    next()
})

export default router
